export default function truncateString(text, length) {
  if (text.length > length) {
    return text.substring(0, length);
  }
  return text;
}


// WEBPACK FOOTER //
// ./src/utils/truncateString.js